var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-in-google"},[_c('a',{staticClass:"search-in-google__link",attrs:{"href":_vm.href,"target":"_blank"}},[_c('base-material-design-icon',{staticClass:"search-in-google__icon",attrs:{"icon":"searchWeb"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }